export default {"src":"/_next/static/media/businessProtectInfo.da5b3a09.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};